import type { StatusColor } from '@ztechapps/common.contract'
import { ChatStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export type ChatStatusDetailType = {
  description: string
  value: ChatStatusEnum
} & StatusColor

export type ChatStatusType = {
  new: ChatStatusDetailType
  pending: ChatStatusDetailType
  open: ChatStatusDetailType
  closed: ChatStatusDetailType
  cancelled: ChatStatusDetailType
}

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const chatStatusColor: ChatStatusType = {
  new: {
    value: ChatStatusEnum.New,
    description: 'A new conversation, from a customer or from staff, not yet worked.',
    // The sales order quotation's own blue (libs/order/common/src/order/OrderStatus.ts:37) —
    // New reads as the same quotation blue, not a second blue.
    color: 'var(--status-custom-blue)',
  },
  pending: {
    value: ChatStatusEnum.Pending,
    description: 'Staff are waiting on the customer — we answered and the ball is in their court.',
    tone: StatusToneEnum.InProgress,
  },
  open: {
    value: ChatStatusEnum.Open,
    description: 'The customer is waiting on staff — a reply has come in and someone owes an answer.',
    tone: StatusToneEnum.Failure,
  },
  closed: {
    value: ChatStatusEnum.Closed,
    description: 'Nothing further is required.',
    tone: StatusToneEnum.Active,
  },
  cancelled: {
    value: ChatStatusEnum.Cancelled,
    description: 'Spam, a duplicate, or something never needed.',
    tone: StatusToneEnum.Cancelled,
  },
}
